import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icon } from '../Icon';
export const ColorTag = ({ color, icon, text, dataTestId, src, size = 'md', invertedColors = false, rounded = false }) => {
    const colors = !invertedColors
        ? [
            { 'bg-secondary-100 text-secondary-600': color === 'secondary' },
            { 'bg-primary-100 text-primary': color === 'primary' },
            { 'bg-primary-50 text-primary-700': color === 'charcoal' },
            { 'bg-red-100 text-red': color === 'red' },
            { 'bg-orange-100 text-orange': color === 'orange' },
            { 'bg-yellow-100 text-yellow': color === 'yellow' },
            { 'bg-green-100 text-green': color === 'green' },
            { 'bg-blue-100 text-blue': color === 'blue' },
            { 'bg-violet-100 text-violet': color === 'violet' },
            { 'bg-pink-100 text-pink': color === 'pink' },
            { 'bg-gray-800/5 text-gray-600': color === 'gray' },
            { 'bg-warm-gray-100 text-warm-gray-600': color === 'warm-gray' }
        ]
        : [
            { 'bg-secondary-600 text-secondary-100': color === 'secondary' },
            { 'bg-primary text-primary-100': color === 'primary' },
            { 'bg-primary-700 text-primary-200': color === 'charcoal' },
            { 'bg-red text-red-100': color === 'red' },
            { 'bg-orange text-orange-100': color === 'orange' },
            { 'bg-yellow text-yellow-100': color === 'yellow' },
            { 'bg-green text-green-100': color === 'green' },
            { 'bg-blue text-blue-100': color === 'blue' },
            { 'bg-violet text-violet-100': color === 'violet' },
            { 'bg-pink text-pink-100': color === 'pink' },
            { 'bg-gray-600 text-white/80': color === 'gray' },
            { 'bg-warm-gray-600 text-warm-gray-50': color === 'warm-gray' }
        ];
    const className = classNames('flex items-center justify-center gap-1 w-fit font-semibold', { 'py-1 px-2 text-sm': size === 'md' }, { 'py-0.5 px-1 text-xs': size === 'sm' }, { 'py-1 px-2 text-mBase': size === 'lg' }, rounded ? 'rounded-full' : 'rounded', ...colors);
    const iconClassName = 'w-4 h-4 flex-none';
    const imageClassName = `${iconClassName} rounded-full object-cover`;
    return (_jsxs("div", { className: className, "data-testid": dataTestId, children: [src && _jsx("img", { alt: "", className: imageClassName, src: src }), icon && !src && _jsx(Icon, { className: iconClassName, name: icon }), text] }));
};
